import ShopifyObject from './ShopifyObject';

export default class VariantFeaturedImage extends ShopifyObject {
  /**
   * @param {ShopifyVariantFeaturedImage} featuredImage
   */
  constructor(featuredImage) {
    super(featuredImage.id);

    this._productId = featuredImage.product_id || 0;
    this._position = featuredImage.position || 0;
    this._createdAt = featuredImage.created_at || new Date(0);
    this._updatedAt = featuredImage.updated_at || new Date(0);
    this._alt = featuredImage.alt || null;
    this._width = featuredImage.width || 0;
    this._height = featuredImage.height || 0;
    this._src = featuredImage.src || '';
    this._variantIds = featuredImage.variant_ids || [];
  }

  /**
   * @returns {number}
   */
  get productId() {
    return this._productId;
  }

  /**
   * @returns {number}
   */
  get position() {
    return this._position;
  }

  /**
   * @returns {Date}
   */
  get createdAt() {
    return this._createdAt;
  }

  /**
   * @returns {Date}
   */
  get updatedAt() {
    return this._updatedAt;
  }

  /**
   * @returns {string}
   */
  get alt() {
    return this._alt;
  }

  /**
   * @returns {number}
   */
  get width() {
    return this._width;
  }

  /**
   * @returns {number}
   */
  get height() {
    return this._height;
  }

  /**
   * @returns {string}
   */
  get src() {
    return this._src;
  }

  /**
   * @returns {number[]}
   */
  get variantIds() {
    return this._variantIds;
  }

  /**
   *
   * @return {Object} - Shopify Variant Featured Image Object.
   */
  JSON() {
    return {
      alt: this.alt,
      created_at: this.createdAt,
      height: this.height,
      id: super.id,
      position: this.position,
      product_id: this.productId,
      src: this.src,
      updated_at: this.updatedAt,
      variant_ids: this.variantIds,
      width: this.width,
    };
  }
}
